<script>
    import { setContext } from "svelte";
    import { writable } from "svelte/store";
    
    import NotificationPrompt from "../components/NotificationPrompt.svelte";
    import NotificationMessage from "../components/NotificationMessage.svelte";
    
    const def_text = "Settings are applied successfully!";
    const def_buttons = ["Confirm", "Cancel"];
    
    const notifs_queue = []
    
    const create_notification = () => {
        const { subscribe, set, update } = writable({
            open: false,
            type: 0,
            text: def_text,
            outcome: -1,
            buttons: def_buttons,
            callback: ()=>{}
        });
    
        return {
            subscribe,
            toggle_notification: (type, text, buttons, callback) => update(data => {
                data.open = true;
                data.type = type;
                data.text = text;
                data.buttons = buttons;
                data.callback = callback
                console.error(data);
                
                switch (type) {
                case 0:
                    setTimeout(() => {
                        set({ open: false });
                    }, 4500);
                    break;
                case 1:
                    setTimeout(() => {
                        set({ open: false });
                    }, 2000);
                    break;
                case 2:
                    break;
                default:
                    data.open = false;
                    data.notification_prompt = false;
                    console.error(`UNKNOWN NOTIFICATION TYPE ${type}`);
                    break;
                }
                return data;
            }),
            close_notification: () => update(data => {
                data.open = false;
                return data;
            }),
            handle_outcome: (outcome) => update(data => {   
                data.open = false;
                if (outcome) data.callback();
                return data;
            }),
        };
    }
    
    const notification = create_notification();
    
    setContext("notification", {
        notification: notification,
    })
    
    </script>
    
{#if $notification.open}
    {#if $notification.type > 1}
        <NotificationPrompt />
    {:else}
        <NotificationMessage />
    {/if}
{/if}

<slot />